// extracted by mini-css-extract-plugin
export default {"curtain":"App_curtain__THBEB","widget":"App_widget__RwPGB","container":"App_container__yqiFM","widgetContainer":"App_widgetContainer__bRQDo"};